import { reservationIdFromAny } from "../ultra/reservationRowUtils";

const EMPTY_LIST = [];

function getSocketMutationAction(payload) {
   if (!payload || typeof payload !== "object") return "";
   return String(
      payload?.action ?? payload?.type ?? payload?.op ?? payload?.operation ?? "",
   )
      .trim()
      .toLowerCase();
}

export function inferSocketMutationOp(eventName, payload) {
   const joined = [
      String(eventName || "").trim().toLowerCase(),
      getSocketMutationAction(payload),
   ]
      .filter(Boolean)
      .join("|");

   if (/delete|deleted|remove|removed|cancel|cancelled|canceled/i.test(joined)) {
      return "delete";
   }
   if (/create|created|insert|added|add/i.test(joined)) {
      return "create";
   }
   if (/update|updated|patch|patched|edit|edited|change|changed/i.test(joined)) {
      return "update";
   }
   return "unknown";
}

export function extractSocketMutationRows(payload) {
   if (!payload || typeof payload !== "object") return EMPTY_LIST;
   if (Array.isArray(payload?.reservations)) return payload.reservations;
   if (Array.isArray(payload?.items)) return payload.items;
   if (Array.isArray(payload?.list)) return payload.list;
   if (payload?.reservation && typeof payload.reservation === "object") {
      return [payload.reservation];
   }
   if (reservationIdFromAny(payload)) return [payload];
   return EMPTY_LIST;
}

export function extractSocketDeleteIds(eventName, payload) {
   const ids = [];
   const pushId = (value) => {
      if (value == null) return;
      const id = String(value).trim();
      if (!id || ids.includes(id)) return;
      ids.push(id);
   };

   const rows = extractSocketMutationRows(payload);
   for (const row of rows) {
      pushId(reservationIdFromAny(row));
   }

   if (!ids.length) {
      pushId(
         payload?.id ??
            payload?.reservationId ??
            payload?.reservation_id ??
            payload?.rid ??
            payload?.reservation?.id ??
            null,
      );
   }

   if (ids.length) return ids;

   const lowerEvent = String(eventName || "").trim().toLowerCase();
   if (!/delete|removed|cancel/i.test(lowerEvent)) return EMPTY_LIST;
   return EMPTY_LIST;
}
